export const DEFAULT_PERCENTAGE = 100;
export const DEFAULT_TTL = -1;
export const DEFAULT_PREFIX = 'locale_settings';
